<template>
    <ion-page>
        <ion-content class="--app-layout">
            <ArticleContent :slug="slug" :title="true" />
        </ion-content>
    </ion-page>
</template>

<script setup>
import _ from 'lodash';

const route = useRoute();
const slug = computed(() => route.params.slug);
</script>

<style lang="scss" scoped></style>
